module.exports = __webpack_public_path__ + "img/home-message.24879c9e.svg";